/* 
 Using this context, we need to handle
 playing one audio at a time
*/

import { ReactNode, createContext, useContext, useState } from 'react';

type ContextType = {
  currentPlayingAudioKey: string | null;
  clearPlayingAudio: VoidFunction;
  setAudioKeyToPlay: (key: string) => void;
};

const defaultValues = {
  currentPlayingAudioKey: '',
  clearPlayingAudio: () => {},
  setAudioKeyToPlay: () => {},
};

const CurrentAudioPlayingContext = createContext<ContextType>(defaultValues);

// eslint-disable-next-line react-refresh/only-export-components
export function useAudioPlayingContext() {
  const ctx = useContext(CurrentAudioPlayingContext);
  return ctx;
}

export function CurrentAudioPlayingProvider({ children }: { children: ReactNode }) {
  const [currentPlayingAudioKey, setAudioKey] = useState<null | string>(null);

  function clearPlayingAudio() {
    setAudioKey(null);
  }
  function setAudioKeyToPlay(key: string) {
    setAudioKey(key);
  }

  return (
    <CurrentAudioPlayingContext.Provider
      value={{
        currentPlayingAudioKey,
        clearPlayingAudio,
        setAudioKeyToPlay,
      }}
    >
      {children}
    </CurrentAudioPlayingContext.Provider>
  );
}
